import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IHistoryState } from 'types/History';
import { getHistoryThunk } from './historyThunk';
import { formatClaimHistory } from './historyUtils';

const initialState: IHistoryState = {
	claimHistory: [],
};

export const getHistory = createAsyncThunk(
	'history/getHistory',
	getHistoryThunk,
);

const historySlice = createSlice({
	name: 'history',
	initialState,
	reducers: {
		resetHistory: state => {
			state.claimHistory = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getHistory.fulfilled, (state, { payload }) => {
			if (!payload) {
				return;
			}

			state.claimHistory = formatClaimHistory(payload);
		});
	},
});

export const { resetHistory } = historySlice.actions;
export default historySlice.reducer;
